import { useContext } from 'react';
import { Context } from '../../context/UserContext';

import styles from './TextArea.module.css';

function TextArea({
    type,
    text,
    name,
    placeholder,
    handleOnChange,
    handleOnBlur,
    handleOnFocus,
    value,
    title,
    required,
    readonly,
    min,
    max,
    textAlign,
    linhas = 5,
    colunas = 80,
    padding = '10px',
    //width = "100%",
    //height = "auto",
    fontSize = '16px',
    fontWeight = 'normal', //bold ou normal
    hidden = false,
}) {
    //configura o tema
    const { parametro } = useContext(Context);

    return (
        <div className={`${styles.form_control} ${styles[parametro.tema]}`}>
            <label htmlFor={name} title={title}>
                {hidden ? '' : `${text}:`}
            </label>
            <textarea
                type={type}
                name={name}
                id={name}
                placeholder={placeholder}
                onChange={handleOnChange}
                onBlur={handleOnBlur}
                onFocus={handleOnFocus}
                title={title}
                required={required}
                style={{
                    textAlign: textAlign,
                    fontSize: fontSize,
                    fontWeight: fontWeight, // ✅
                    padding: padding,
                    //width: "100%",
                    //height: "auto",
                }}
                readOnly={readonly === true ? true : false}
                min={min}
                max={max}
                cols={colunas}
                rows={linhas}
                value={value}
                hidden={hidden}
            />
        </div>
    );
}

export default TextArea;
